<template>
  <div class="loading-container" v-loading="true"></div>
</template>

<script>
import { loginCheckpoint } from "../../api/wap/vietin";
import { setFlag, setLanguage } from "../../../utils/wapAuth";
export default {
  created() {
    let data = this.$router?.history?.current?.query?.data.replaceAll(" ", "+");
    loginCheckpoint({ data }).then(res => {
      if (res.error_code === 0) {
        setFlag(res.data.flag);
        setLanguage(res.data.language);
        window.location.href = `/navigate?token=${res.data.token}`;
      } else if (res.error_code === 2) {
        window.location.href = res.url;
      } else {
        // if (res.error_msg.includes("Bạn vừa lấy mã xác nhận"))
        //   this.$message.error(res.error_msg);
        // else window.location.href = "/404";
        this.$message.error(res.error_msg);
      }
    });
  }
};
</script>
<style scoped>
.loading-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
